import { addDays, format, startOfDay } from 'date-fns';
import React from 'react';
import getDaysArray from '../../../../../../lib/utils/get-days-array';
import { TDay } from '../../../../../../types/e-visits';
import { IMarkedEvents, TWeekStart } from '../../../calendars';
import WeekDay from '../week-day';

interface WeekProps {
  /**
   * Date on which week starts
   */
  weekStart: string;
  /**
   * Min hour to determine offset from top
   */
  minHour: number;
  /**
   * Display colored ranges in background of events
   */
  markedEvents?: IMarkedEvents;
  /**
   * Day of week to show first
   */
  weekStartsOn: TWeekStart;

  onClick: (e: any, rect: any, date: any) => void;
}

/**
 * Element do render whole week in calendar
 */
const Week: React.FunctionComponent<WeekProps> = ({
  weekStart,
  markedEvents,
  minHour,
  weekStartsOn,
  onClick,
}) => {
  const startDate = startOfDay(new Date(weekStart));
  const weekDays = getDaysArray<TDay>(weekStartsOn, 'number');

  return (
    <>
      {weekDays.map((d, i) => {
        const date = addDays(startDate, i);
        const dateDate = format(date, 'yyyy-MM-dd');

        return (
          <WeekDay
            key={d}
            date={dateDate}
            markedEvents={markedEvents?.[dateDate]}
            minHour={minHour}
            onClick={onClick}
            isFirstDay={i === 0}
            isLastDay={i === weekDays.length - 1}
          />
        );
      })}
    </>
  );
};

export default React.memo(Week);
